<template>
  <div id="open-order">

    <div class="vx-row mb-base" >
      <!-- CARD 9: DISPATCHED ORDERS -->
      <div class="vx-col w-full">
        <vx-card title="معاملات باز شما">
          <div slot="no-body" class="mt-4" id="TableOpenOrders">
            <vs-table :data="openOrders" :noDataText="$t('No data Available')" class="table-dark-inverted">
              <template slot="thead">
                <vs-th class="w-130">تاریخ و زمان</vs-th>
                <vs-th class="w-150">بازار</vs-th>
                <vs-th>خرید/فروش</vs-th>
                <vs-th>نوع سفارش</vs-th>
                <vs-th>قیمت هر واحد</vs-th>
                <vs-th>مقدار</vs-th>
                <!--<vs-th class="w-150">درصد انجام</vs-th>-->
                <vs-th class="w-75">جزئیات بیشتر</vs-th>
                <vs-th>لغو</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].dateTime">
                    <span class="flex items-center pr-2 py-1 vazir"><div class="h-3 w-3 rounded-full mr-2" :class="'bg-' + (data[indextr].type == 'buy'? 'success' : 'danger' )"></div>
                      {{data[indextr].dateTime}}
                    </span>
                  </vs-td>
                  <vs-td>
                    <div class="flex items-center">
                      <div class="pr-2 quoteAsset">
                        <i class="text-3xl cf" v-if="isFontExist(data[indextr].quoteSymbol)" :class="'cf-'+ data[indextr].quoteSymbol.toLowerCase()" :style="{color:colorSymbol(data[indextr].quoteSymbol)}"></i>
                        <img :src="publicPath+'images/currency/' + iconSymbol(data[indextr].quoteSymbol)" width="25px" height="25px" v-else/>
                      </div>
                      <div class="pr-2 baseAsset">
                        <i class="text-3xl cf" v-if="isFontExist(data[indextr].baseSymbol)" :class="'cf-'+ data[indextr].baseSymbol.toLowerCase()" :style="{color:colorSymbol(data[indextr].baseSymbol)}"></i>
                        <img :src="publicPath+'images/currency/' + iconSymbol(data[indextr].baseSymbol)" width="25px" height="25px" v-else/>
                      </div>
                      <div class="capitalize">{{data[indextr].marketName}}</div>
                    </div>
                  </vs-td>
                  <vs-td :data="data[indextr].type">
                    <span class="flex items-center">
                      <div class="h-3 w-3 rounded-full mr-2" :class="'bg-' + (data[indextr].type == 'buy'? 'success' : 'danger' )"></div>
                      <span>{{$t(data[indextr].type)}}</span>
                    </span>
                  </vs-td>
                  <vs-td :data="data[indextr].model">
                    {{($t(data[indextr].model))}}
                    <small>({{data[indextr].model}})</small>
                  </vs-td>
                  <vs-td :data="data[indextr].fee">
                    <span>{{toFixFloat(data[indextr].fee)}} <small>{{$t(data[indextr].quoteSymbol)}}</small></span>
                  </vs-td>
                  <vs-td :data="data[indextr].amountBase">
                    <span>{{ toFixFloat(data[indextr].amountBase)}} <small>{{data[indextr].baseSymbol}}</small></span>
                  </vs-td>
                  <!--
                  <vs-td>
                    <span>{{toFixFloat(data[indextr].sumTradeAmount)}} (%{{data[indextr].percentTradeAmount}})</span>
                    <vs-progress :percent="data[indextr].percentTradeAmount" :color="data[indextr].type == 'buy'? 'success' : 'danger'"></vs-progress>
                  </vs-td>
                  -->
                  <vs-td>
                    <span @click="popupDetail=true;idOrder=data[indextr].id" class="cursor-pointer">
                        <feather-icon icon="AirplayIcon" class="text-primary px-6"></feather-icon>
                    </span>
                  </vs-td>
                  <vs-td>
                    <span>
                      <vs-tooltip color="danger" delay="1s" text="حذف سفارش">
                         <feather-icon icon="Trash2Icon" class="text-danger cursor-pointer" :id="'btn-remove-trade-'+data[indextr].id"
                                       @click="removeTrade(data[indextr].id)"></feather-icon>
                      </vs-tooltip>
                    </span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>

        </vx-card>
      </div>
    </div>

    <div v-if="idOrder">
      <Detail :popupDetail="popupDetail" :idOrder="idOrder" @removeTrade="removeTrade" v-on:popupDetailChange="updatePopupDetail"/>
    </div>

  </div>
</template>
<i18n locale="fa">
  {
  "limit": "محدود",
  "stop-limit": "حد توقف",
  "oco": "ترکیبی",
  "market": "سریع"
  }
</i18n>
<script>
  import Detail from '../tools/history/trades/Detail.vue'
  import axios from "../../axios";
  export default {
    name: 'OpenOrers',
    data () {
      return {
        popupDetail: false,
        idOrder:null,
        openOrders: [],
        callIds : []
      }
    },
    components: {
      Detail
    },
    created () {
      this.getList()
      this.socketUpdate()
    },
    methods: {
      socketUpdate(){
        this.$echo.private(`user.${  this.activeUserInfo.id}`).listen("Market.updateOpenOrder", (payload) => {
          this.getList();
        })
      },
      updatePopupDetail (value) {
        this.popupDetail = value
      },
      getList(){
        const self = this
        axios.post('/order-open',{open:true}).then(function (response) {
          self.openOrders = response.data.orders;

        }).catch(function (error) { console.log(error); })
      },
      removeTrade(id){
        if(this.callIds.includes(id))
          return;
        this.callIds.push(id);
        this.$vs.loading({
          container: '#btn-remove-trade-'+id,
          scale: 0.65
        })
        var self = this;
        axios.delete('/market/cancell/'+id)
          .then(function (response) {
            if (response.data.status == true) {
              self.$swal({
                icon: 'success',
                title: self.$t('Success'),
                text: response.data.msg
              })
              self.amount = '';
              self.fee = '';
              self.popupDetail = false;
              self.getList()
            }else{
              self.getList()
              self.$swal({
                icon: 'warning',
                title: self.$t('Warning'),
                text: response.data.msg
              })
            }
            self.$vs.loading.close('#btn-remove-trade-'+id+' > .con-vs-loading');
            self.isLoading = false;
            self.callIds.splice(self.callIds.indexOf(id), 1);
          }).catch(function (error) { self.$vs.loading.close('#btn-remove-trade-'+id+' > .con-vs-loading'); self.callIds.splice(self.callIds.indexOf(id), 1); })
      },

    }
  }
</script>


<style lang="scss">
  #open-order {
    .quoteAsset{
      opacity: 0.5;
      margin-right: -18px;
      z-index: 0;
    }
    .baseAsset{
      z-index: 1;
    }

    .w-130 .vs-table-text{
      min-width: 120px;
    }
    .w-150 .vs-table-text{
      min-width: 150px;
    }
    .w-75 .vs-table-text{
      min-width: 75px;
    }

    .greet-user{
      position: relative;

      .decore-left{
        position: absolute;
        left:0;
        top: 0;
      }
      .decore-right{
        position: absolute;
        right:0;
        top: 0;
      }
    }

    @media(max-width: 576px) {
      .decore-left, .decore-right{
        width: 140px;
      }
    }
  }
  /*! rtl:end:ignore */
</style>

